import React from "react";
// react library for routing
import { Route, Switch, Redirect } from "react-router-dom";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar";
import AdminFooter from "../components/Footers/AdminFooter.jsx";
import Sidebar from "../components/Sidebar/Sidebar.jsx";
import Wellcome from "../layouts/Wellcome";
import NotFound from "../layouts/NotFound";
import AuthContext from "../contexts/Auth";
import AlertaBanner from "../components/AlertaBanner";

//import routes from "../routes";
import { getComponent } from "../routes/componentsPath";
import playneeLogo from "../assets/img/brand/full_logo_ligth.png";

class Admin extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      sidenavOpen: false,
      menus: [],
      sidebarMenus: [],
      routes: [],
      isMobile: window.innerWidth <= 768,
    };
    this.handleResize = () => {
      this.setState({ isMobile: window.innerWidth <= 768 });
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);

    // Sem o hover, nada mais marcava o body na primeira renderizacao e o menu
    // ficava num estado indefinido. Deixa explicito que comeca fechado.
    document.body.classList.remove("g-sidenav-pinned", "g-sidenav-show");
    document.body.classList.add("g-sidenav-hidden");

    // monta as rotas dinâmicas
    this.getRoutes(this.state.routes);

    // depois que montou, tenta mandar o comercial pra /admin/oportunidades
    this.redirectIfComercial();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps) {
    // comportamento que você já tinha (scroll pro topo quando troca de rota)
    if (
      prevProps.history?.pathname !== this.props.history?.pathname ||
      prevProps.location?.pathname !== this.props.location?.pathname
    ) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      if (this.refs.mainContent) {
        this.refs.mainContent.scrollTop = 0;
      }
    }

    // garante que, se o cara cair em /admin depois, ainda redireciona
    this.redirectIfComercial();
  }

  redirectIfComercial = () => {
    const { user } = this.context;
    const { pathname } = this.props.location;

    const hasPerfilComercial = user?.roles?.some(
      (role) => role.slug === "comercial"
    );

    if (
      hasPerfilComercial &&
      (pathname === "/admin" || pathname === "/admin/")
    ) {
      this.props.history.replace("/admin/oportunidades");
    }
  };

  changeRoutes(routes) {
    // console.log('ENTROU NO CHANGEROUTES ADMIN.jsx')
    // console.log({ routes })
    if (routes && routes.length > 0) {
      // console.log('ROUTES ENCONTRADAS')
      //this.state.routes = routes
      this.setState({
        ...this.state,
        routes,
      });
      //this.getRoutes(this.state.routes)
      this.getRoutes(routes);
    }
  }

  createMenu(item) {
    const object = getComponent(item.path);
    const routeMenu = this.createMenuRoute(item);
    if (routeMenu) {
      //Se existir uma rota para esse menu...
      const menus = this.state.menus;
      menus.push(routeMenu);
      this.setState({ ...this.state, menus });
    }
    return {
      alias: item.alias,
      path: item.path,
      compotent: object ? object.component : null,
      name: item.nome,
      ordem: item.ordem,
      icon: item.icon,
      layout: "/admin",
    };
  }

  createMenuRoute(item) {
    if (item.path) {
      const object = getComponent(item.path);
      return (
        <Route
          key={"key-item-" + item.id}
          path={"/admin" + item.path}
          exact
          component={object ? object.component : NotFound}
        />
      );
    }
  }

  getRoutes(routes) {
    //const response = await routes();
    const response = routes;
    // console.log('GET ROUTES ADMIN.jsx')
    // console.log({ routes })
    const hiddenPaths = ["/programa-de-indicacao", "/minhas-conversas"];
    let sidebarMenus = response.filter((item) => !item.hidden && !hiddenPaths.includes(item.path));
    sidebarMenus = sidebarMenus.map((prop) => {
      const item = this.createMenu(prop);
      if (prop.menus && prop.menus.length > 0) {
        item["views"] = prop.menus
          .filter((obj) => !hiddenPaths.includes(obj.path))
          .map((obj) => this.createMenu(obj));
        item["collapse"] = true;
        item["state"] = prop.alias;
      }
      return item;
    });

    //Cria as rotas para os menus foras da sidebar
    response.filter((item) => item.hidden).map((item) => this.createMenu(item));

    this.setState({
      ...this.state,
      sidebarMenus,
    });
  }

  getBrandText = (path) => {
    for (let i = 0; i < this.state.routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          this.state.routes[i].layout + this.state.routes[i].path
        ) !== -1
      ) {
        return this.state.routes[i].name;
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  toggleSidenav = (e) => {
    // g-sidenav-show era ligada pelo hover e e ela que mantem os submenus
    // abertos (height: auto). Agora acompanha o estado do botao.
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned", "g-sidenav-show");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned", "g-sidenav-show");
      document.body.classList.remove("g-sidenav-hidden");
    }
    this.setState({
      sidenavOpen: !this.state.sidenavOpen,
    });
  };
  getNavbarTheme = () => {
    return this.props.location.pathname.indexOf(
      "admin/alternative-dashboard"
    ) === -1
      ? "dark"
      : "light";
  };

  render() {
    return (
      <>
        <Sidebar
          {...this.props}
          routes={this.state.sidebarMenus}
          toggleSidenav={this.toggleSidenav}
          sidenavOpen={this.state.sidenavOpen}
          logo={{
            innerLink: "/",
            imgSrc: playneeLogo,
            imgAlt: "...",
          }}
        />
        {/* Barra topo mobile - z-index abaixo do sidebar (1050) para não cobrir */}
        {this.state.isMobile && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              height: "56px",
              background: "white",
              zIndex: 1040,
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
          />
        )}
        <div
          className="main-content"
          ref="mainContent"
          onClick={this.closeSidenav}
          style={this.state.isMobile ? { paddingTop: "56px" } : undefined}
        >
          <AdminNavbar
            {...this.props}
            theme={this.getNavbarTheme()}
            toggleSidenav={this.toggleSidenav}
            sidenavOpen={this.state.sidenavOpen}
            brandText={this.getBrandText(this.props.location.pathname)}
            changeRoutes={this.changeRoutes.bind(this)}
          />
          <AlertaBanner />
          {window.location.pathname === "/admin" ||
          window.location.pathname === "/admin/" ? (
            <Wellcome />
          ) : (
            <Switch>{this.state.menus}</Switch>
          )}
          {/* <AdminFooter /> */}
        </div>
        {this.state.sidenavOpen ? (
          <div className="backdrop d-xl-none" onClick={this.toggleSidenav} />
        ) : null}
      </>
    );
  }
}

export default Admin;
